import { Info, ArrowLeft, CheckCircle2 } from 'lucide-react';

export function QualitaetsAnzeige({ ansicht, onZurueckZurEingabe, t }) {
  const merkmale = ansicht?.erkannt?.erkannte_merkmale || [];
  const total = merkmale.length;
  const erkannt = merkmale.filter(m => m.erkannt).length;

  if (total === 0) return null;

  const prozent = Math.round((erkannt / total) * 100);
  const istVollstaendig = prozent >= 80;
  const istDuenn = prozent < 50;

  return (
    <div
      className={`mb-5 p-3.5 rounded-xl border flex items-start gap-3 ${
        istVollstaendig
          ? 'border-emerald-200 bg-emerald-50/50'
          : istDuenn
            ? 'border-amber-200 bg-amber-50/50'
            : 'border-warm-200 bg-warm-50/50'
      }`}
      data-testid="qualitaets-anzeige"
    >
      <div className="shrink-0 mt-0.5">
        {istVollstaendig
          ? <CheckCircle2 className="h-4 w-4 text-emerald-600" />
          : <Info className="h-4 w-4 text-amber-600" />
        }
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <p className="text-xs font-medium text-foreground">
            {t('qualitaet.basis')} {erkannt} {t('qualitaet.von')} {total} {t('qualitaet.angaben')}
          </p>
          <span className={`text-[11px] font-semibold ${istVollstaendig ? 'text-emerald-700' : istDuenn ? 'text-amber-700' : 'text-foreground'}`}>
            {prozent}%
          </span>
        </div>

        {/* Progress bar */}
        <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden mb-2">
          <div
            className={`h-full rounded-full transition-all duration-500 ${
              istVollstaendig ? 'bg-emerald-500' : istDuenn ? 'bg-amber-400' : 'bg-primary/60'
            }`}
            style={{ width: `${prozent}%` }}
          />
        </div>

        {!istVollstaendig && (
          <p className="text-[11px] text-muted-foreground leading-relaxed">
            {t('qualitaet.hinweis')}
          </p>
        )}

        {istDuenn && onZurueckZurEingabe && (
          <button
            onClick={onZurueckZurEingabe}
            className="mt-2 inline-flex items-center gap-1 text-[11px] font-medium text-primary hover:text-primary/80 transition-colors"
            data-testid="qualitaet-ergaenzen-btn"
          >
            <ArrowLeft className="h-3 w-3" />
            {t('qualitaet.ergaenzen')}
          </button>
        )}
      </div>
    </div>
  );
}
